import Vue from 'vue';
import VueRouter from 'vue-router';

import { ADMIN_TOKEN_KEY } from '@/config';
import api from '@/utils/api';
import store from '@/store';

import {
  ifAuthenticated,
  ifNotAuthenticated,
  requiredDashboardAccess,
  dontHavePermission,
} from '@/router/helpers';
import Main from '@/views/Main';
import AuthLogin from '@/views/auth/AuthLogin';
import Dashboard from '@/views/Dashboard';
import adminRoutes from '@/router/admin';
import customerRoutes from '@/router/customer';
import reportRoutes from '@/router/report';
import loanRoutes from '@/router/loan';
import officerRoutes from '@/router/officer';
import generalJournalRoutes from '@/router/generalJournal';
import settingsRoutes from '@/router/settings';
import loanSettingsRoutes from '@/router/loanSettings';
import Home from '@/views/Home';

Vue.use(VueRouter);
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const { status } = error.response;
//     if (status === 401) {
//       store.dispatch(AUTH_REFRESH_TOKEN).then(() => {
//         window.location.reload();
//       });
//     }
//     return Promise.reject(error);
//   }
// );

const adminToken = window.$cookies.get(ADMIN_TOKEN_KEY);
if (adminToken) {
  api.defaults.headers.common.Authorization = `Bearer ${adminToken}`;
} else {
  delete api.defaults.headers.common.Authorization;
}

const routes = [
  {
    path: '/login',
    name: 'AdminLogin',
    component: AuthLogin,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/',
    component: Main,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: requiredDashboardAccess,
        meta: {
          roles: ['ADMINISTRATOR', 'STATISTICS', 'VIEWER'],
        },
      },
      ...adminRoutes,
      ...customerRoutes,
      ...reportRoutes,
      ...loanRoutes,
      ...officerRoutes,
      ...generalJournalRoutes,
      ...settingsRoutes,
      ...loanSettingsRoutes,
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Global navigation guard for role-based access control
router.beforeEach((to, from, next) => {
  // Check if route has role restrictions
  if (to.meta && to.meta.roles) {
    const userRole = store.getters.me?.role;

    if (!userRole) {
      // User not loaded yet, let the route's beforeEnter handle it
      next();
      return;
    }

    if (!to.meta.roles.includes(userRole)) {
      dontHavePermission(to, from, next);
      return;
    }
  }

  next();
});

export default router;
